var map = {
	"./pr-1.png": "8d9b",
	"./pr-2.png": "7b97",
	"./pr-3.png": "2f57",
	"./pr-4.png": "3773",
	"./pr-5.png": "5173",
	"./pr-6.png": "9bf1",
	"./pr-7.png": "2698",
	"./pr-8.png": "c962",
	"./pr-9.png": "1929"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0490";